import React, { useState } from 'react';
import { Grid, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
// Wrap the component with React.memo to prevent unnecessary re-renders
import AddDataModal from './AddDataModal';

const LeftSideVitalsTabs = React.memo(
  ({ handleLeftTabClick, leftTabMenu, activeTab, isActivitiesTab, activitiesData, userData, recipientId }) => {
    const userId = recipientId || userData?._id;
    // Modal state
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Modal handlers
    const handleOpenModal = () => {
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
    };

    // Memoize the getStatusIcon function to prevent recreation on every render
    const getStatusIcon = React.useCallback((tabName) => {
      if (['Heart Rate', 'Blood Pressure', 'Calories', 'Glucose'].includes(tabName)) {
        return <CheckCircleIcon style={{ color: '#4CAF50', fontSize: '18px', marginRight: '8px' }} />;
      } else {
        return <AccessTimeIcon style={{ color: '#9e9e9e', fontSize: '18px', marginRight: '8px' }} />;
      }
    }, []);
    // Add helper function to check if tab should be disabled
    const isTabDisabled = React.useCallback(
      (tabName) => {
        if (isActivitiesTab) {
          return !['Distance', 'Steps', 'Sleep'].includes(tabName);
        } else {
          return !['Heart Rate', 'Blood Pressure', 'Calories', 'Glucose'].includes(tabName);
        }
      },
      [isActivitiesTab],
    );

    const getPercentage = React.useCallback((item) => {
      // return <span style={{ marginRight: '8px' }}>{item.percentage}</span>;
      return <span style={{ marginRight: '8px' }}></span>;
    }, []);
    return (
      <Grid container direction="column" spacing={1.5}>
        {isActivitiesTab ? (
          <>
            {activitiesData.map((item, idx) => (
              <Grid item key={idx}>
                <Chip
                  className={`custom-chip ${activeTab === item.name ? 'active' : ''}`}
                  style={{
                    border: 'none',
                    opacity: isTabDisabled(item.name) ? 0.5 : 1,
                    cursor: isTabDisabled(item.name) ? 'not-allowed' : 'pointer',
                  }}
                  label={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        paddingRight: '8px',
                        color: isTabDisabled(item.name) ? '#9e9e9e' : 'inherit',
                      }}
                    >
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.name}</span>
                      <span style={{ flexShrink: 0 }}>{getPercentage(item)}</span>
                    </div>
                  }
                  onClick={() => !isTabDisabled(item.name) && handleLeftTabClick(item.name)}
                  sx={{
                    width: '100%',
                    height: '42px',
                    justifyContent: 'flex-start',
                    border: activeTab === item.name ? 'none' : '1px solid #e0e0e0',
                    backgroundColor: activeTab === item.name ? '#f5f5f5' : 'white',
                    borderRadius: '24px',
                    '&:hover': {
                      backgroundColor: activeTab === item.name ? '#f0f0f0' : '#f9f9f9',
                    },
                    '& .MuiChip-label': {
                      padding: '0 0 0 12px',
                      width: '100%',
                      display: 'block',
                    },
                  }}
                />
              </Grid>
            ))}
            {activeTab !== 'Sleep' && (
              <Box sx={{ mt: 'auto', mb: 4, display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleOpenModal}
                  sx={{
                    borderRadius: '24px',
                    backgroundColor: '#3b9b8f',
                    '&:hover': {
                      backgroundColor: '#2d7a70',
                    },
                  }}
                  size="large"
                >
                  Add manually
                </Button>
              </Box>
            )}
            <AddDataModal open={isModalOpen} handleClose={handleCloseModal} dataType={activeTab} userId={userId} />
          </>
        ) : (
          leftTabMenu.map((item, idx) => (
            <Grid item key={idx}>
              <Chip
                className={`custom-chip ${activeTab === item ? 'active' : ''}`}
                style={{
                  border: 'none',
                  opacity: isTabDisabled(item) ? 0.5 : 1,
                  cursor: isTabDisabled(item) ? 'not-allowed' : 'pointer',
                }}
                label={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                      paddingRight: '8px',
                      color: isTabDisabled(item) ? '#9e9e9e' : 'inherit',
                    }}
                  >
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{item}</span>
                    <span style={{ flexShrink: 0 }}>{getStatusIcon(item)}</span>
                  </div>
                }
                onClick={() => !isTabDisabled(item) && handleLeftTabClick(item)}
                sx={{
                  width: '100%',
                  height: '42px',
                  justifyContent: 'flex-start',
                  border: activeTab === item ? 'none' : '1px solid #e0e0e0',
                  backgroundColor: activeTab === item ? '#f5f5f5' : 'white',
                  borderRadius: '24px',
                  '&:hover': {
                    backgroundColor: activeTab === item ? '#f0f0f0' : '#f9f9f9',
                  },
                  '& .MuiChip-label': {
                    padding: '0 0 0 12px',
                    width: '100%',
                    display: 'block',
                  },
                }}
              />
            </Grid>
          ))
        )}
      </Grid>
    );
  },
);

export default LeftSideVitalsTabs;
